// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2rALz","dragIcon":"Choice_dragIcon__3hJis","left":"Choice_left__2Hy88","input":"Choice_input__2SkH6"};